import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';
import WppLogo from '../../assets/whatsapp.png';
import { TrackingContext } from '../../contexts/TrackingContext';
import { useMerchantStore } from '../../stores/merchant';

export const FloatingWhatsappButton: React.FC = () => {
  const links = useMerchantStore((state) => state.links);
  const { track } = React.useContext(TrackingContext);
  const [isVisible, setIsVisible] = React.useState(true);

  const wppLink = links?.find((l) => l.type === 'WHATSAPP');

  if (!wppLink || !wppLink.floating_button || !isVisible) return null;

  return (
    <div className="fixed right-0 bottom-6 m-4 z-[998] flex flex-col items-end gap-2">
      <button
        type="button"
        className="absolute -top-3 -right-1 z-[999] bg-gray-800/80 hover:bg-gray-700/90 text-white rounded-full p-1 transition-colors duration-200 shadow-lg"
        onClick={() => setIsVisible(false)}
        title="Esconder botão do WhatsApp"
      >
        <XMarkIcon className="w-4 h-4" />
      </button>

      <a
        type="button"
        className="text-green-400 rounded-lg block relative"
        href={wppLink.link}
        target="_blank"
        onClick={() => {
          track('OnCustomerClickWhatsAppPill', {});
        }}
      >
        <img
          src={WppLogo}
          alt="Logo do Whatsapp (Chamar loja no whatsapp)"
          className="w-14 h-14"
        />
      </a>
    </div>
  );
};
